<div>
  <ngx-spinner size="medium" color="#fff" [type]="typeSelected" [fullScreen]="true"> </ngx-spinner>
</div>
<div
  *ngrxLet="sharedFacade.isLoaded$ as dataLoaded"
  [ngClass]="{ loaderwrapper: !dataLoaded && submitted }"
>
  <div class="forgotPassword">
    <div class="logo">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6">
            <div class="logo-main">
              <div class="ourlogo">
                <img src="/assets/images/Piqet_NewLogo.png" alt="Logo" />
              </div>
              <div class="rightside-text">
                <div class="logo1">
                  Powering your <br />
                  sustainability journey
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="submit()">
        <div class="content">
          <ng-container
            *ngrxLet="{
              forgotPassword: (authFacade.forgotPassword$ | async),
              isForgotPassword: (authFacade.isForgotPassword$ | async)
            } as forgotPasswordData"
          >
            <div
              *ngIf="!forgotPasswordData.isForgotPassword"
              [ngClass]="
                forgotPasswordData.forgotPassword.messageType === 0
                  ? 'text-success'
                  : 'input-custom'
              "
            >
              {{ forgotPasswordData.forgotPassword.message }}
            </div>
          </ng-container>
          <h3 class="form-title">Reset your password</h3>
          <p class="resetText">
            Enter the email you use to login to PIQET and we'll send you a link to get you back into
            your account.
          </p>

          <div class="form-group required">
            <piqet-angular-common-input
              formControlName="email"
              [control]="forgotPasswordForm.get('email')"
              label="Email"
              placeholder="Email"
              [maxLength]="150"
              [submitted]="submitted"
              [inputType]="'email'"
              [errorMessages]="{
                required: 'The email field is required.',
                email: 'Invalid email address'
              }"
            >
            </piqet-angular-common-input>
          </div>
          <div class="form-actions">
            <button
              type="submit"
              class="box btn blue-hoki pull-right purpleBtnHoverEffect"
              (click)="submit()"
              [disabled]="!forgotPasswordForm.valid"
            >
              Send link
            </button>
          </div>
          <div class="text-center backLogin">
            <a class="linkText" routerLink="/login">Back to log in</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
